import React, { useEffect, useState } from "react";
import StepSatu from "../FormUMK/StepSatu";
import StepDua from "../FormUMK/StepDua";
import StepTiga from "../FormUMK/StepTiga";
import useAxios from "../../../../Utils/useAxios";
import { useParams } from "react-router-dom";
import { addSevenDays, formatRP } from "../../../../Utils/externalFunctions";
import { convertRPInputToIntValue } from "../../../../Utils/otherFunctions";
import { FORM_TYPE } from "../../../../Constant/FormType";
import FormStepContainer from "../../../../Layout/Containers/FormStepContainer";
import {
  getAnggaranDipakaiUMKByID,
  getRencImp,
  getUMKById,
  getUnitKerja,
} from "../services";

const UbahUMK = () => {
  const axiosInstance = useAxios();

  const { formId } = useParams();

  const [rencImp, setRencImp] = useState([]);
  const [unitKerja, setUnitKerja] = useState([]);
  const [anggaranRencimpUMK, setAnggaranRencimpUMK] = useState([]);

  const [formUMK, setFormUMK] = useState([]);

  const [total, setTotal] = useState(0);

  const [addedValueSisa, setAddedValueSisa] = useState([]);
  const [formattedNilai, setFormattedNilai] = useState("0");
  const [anggaranRencimpFormattedNilai, setAnggaranRencimpFormattedNilai] =
    useState([]);

  const [step, setStep] = useState(0);

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      const { data: rencImpData } = await getRencImp(axiosInstance);
      setRencImp(rencImpData);

      const { data: unitKerjaData } = await getUnitKerja(axiosInstance);
      setUnitKerja(unitKerjaData);

      const { data: singleUMKData } = await getUMKById(axiosInstance, formId);
      setFormUMK(singleUMKData);
      setFormattedNilai(formatRP(singleUMKData.nilai.replace(".00", "")));

      const { data: anggaranDipakaiUMKData } = await getAnggaranDipakaiUMKByID(
        axiosInstance,
        singleUMKData.id_umk
      );

      setAnggaranRencimpUMK(() => {
        return anggaranDipakaiUMKData.map((data) => {
          return {
            id_anggaran_dipakai_umk: data.id_anggaran_dipakai_umk,
            rencana_imp: String(data.rencana_imp),
            anggaran_digunakan: convertRPInputToIntValue(
              data.anggaran_digunakan
            ),
          };
        });
      });
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    getAnggaranRencimpFormattedNilai();
  }, [rencImp]);

  useEffect(() => {
    calculateTotal();
  }, [anggaranRencimpUMK]);

  const getAnggaranRencimpFormattedNilai = async () => {
    try {
      await getUMKById(axiosInstance, formId).then(async (response) =>
        getAnggaranDipakaiUMKByID(axiosInstance, response.data.id_umk).then(
          (res) => {
            setAddedValueSisa(res.data);
            res.data.map((data) => {
              setAnggaranRencimpFormattedNilai((prev) => {
                if (prev.length !== 0) {
                  return prev.map((item) => {
                    if (data.rencana_imp === item.pk) {
                      return {
                        ...item,
                        formatted_nilai: formatRP(
                          convertRPInputToIntValue(data.anggaran_digunakan)
                        ),
                        isValid:
                          parseFloat(data.anggaran_digunakan) <=
                          (parseFloat(item.anggaran_tersisa) + parseFloat(data.anggaran_digunakan)),
                      };
                    } else {
                      return item;
                    }
                  });
                } else {
                  return rencImp.map((item) => {
                    if (data.rencana_imp === item.pk) {
                      return {
                        pk: item.pk,
                        formatted_nilai: formatRP(
                          convertRPInputToIntValue(data.anggaran_digunakan)
                        ),
                        anggaran_tersisa:
                          parseFloat(item.anggaran_tersisa) +
                          parseFloat(data.anggaran_digunakan) +
                          ".00",
                        isValid:
                          parseFloat(data.anggaran_digunakan) <=
                          (parseFloat(item.anggaran_tersisa) + parseFloat(data.anggaran_digunakan)),
                      };
                    } else {
                      return {
                        pk: item.pk,
                        formatted_nilai: "0",
                        anggaran_tersisa: item.anggaran_tersisa,
                        isValid: true,
                      };
                    }
                  });
                }
              });
            });
          }
        )
      );
    } catch (e) {
      console.error(e);
    }
  };

  const calculateTotal = () => {
    let sum = 0;
    anggaranRencimpUMK.map((item) => {
      const value = parseFloat(item.anggaran_digunakan);
      if (!isNaN(value)) {
        sum += value;
      }
    });
    setTotal(sum);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "tanggal_selesai") {
      const addedTanggal = addSevenDays(value, 14);
      setFormUMK((prev) => ({
        ...prev,
        tanggal_selesai: value,
        batas_akhir: addedTanggal,
      }));
    } else if (name === "nilai") {
      const numericValue = convertRPInputToIntValue(value);
      setFormUMK((prev) => ({
        ...prev,
        nilai: numericValue,
      }));
      setFormattedNilai(formatRP(numericValue));
    } else {
      setFormUMK((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // const handleCheckbox = (e) => {
  //   const { id, checked } = e.target;
  //   if (checked) {
  //     setFormUMK((prevForm) => ({
  //       ...prevForm,
  //       id_um_list: [...prevForm.id_um_list, id],
  //     }));
  //   } else {
  //     setFormUMK((prevForm) => ({
  //       ...prevForm,
  //       id_um_list: prevForm.id_um_list.filter((item) => item !== id),
  //     }));
  //   }
  // };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    const fieldType = e.target.getAttribute("data-field-type");

    const numericValue = convertRPInputToIntValue(value);

    setAnggaranRencimpFormattedNilai((prev) => {
      return prev.map((item) => {
        if (item.pk === parseInt(id)) {
          return { ...item, formatted_nilai: formatRP(numericValue) };
        } else {
          return item;
        }
      });
    });

    if (numericValue === 0) {
      setAnggaranRencimpUMK((prev) =>
        prev.filter((item) => item.rencana_imp !== id)
      );
    } else {
      setAnggaranRencimpUMK((prev) => {
        const existingObject = prev.find((item) => item.rencana_imp === id);
        if (existingObject) {
          return prev.map((item) =>
            item.rencana_imp === id
              ? { ...item, [fieldType]: numericValue }
              : item
          );
        } else {
          const newObject = {
            id_anggaran_dipakai_umk: formUMK.id_umk,
            rencana_imp: id,
            [fieldType]: numericValue,
          };
          return [...prev, newObject];
        }
      });
    }
  };

  // const handleFileChange = (e) => {
  //   const doc = e.target.files[0];
  //   setFormUMK((prev) => ({
  //     ...prev,
  //     doc: doc,
  //   }));
  // };

  const nextStep = (e) => {
    setStep(step + 1);
  };

  const prevStep = (e) => {
    setStep(step - 1);
  };

  return (
    <FormStepContainer step={step}>
      <StepSatu
        nextStep={nextStep}
        handleChange={handleChange}
        formUMK={formUMK}
        unitKerja={unitKerja}
        formattedNilai={formattedNilai}
      />
      <StepDua
        nextStep={nextStep}
        prevStep={prevStep}
        handleInputChange={handleInputChange}
        total={total}
        rencImp={rencImp}
        anggaranRencimpUMK={anggaranRencimpUMK}
        formUMK={formUMK}
        unitKerja={unitKerja}
        anggaranRencimpFormattedNilai={anggaranRencimpFormattedNilai}
        setAnggaranRencimpFormattedNilai={setAnggaranRencimpFormattedNilai}
        addedValueSisa={addedValueSisa}
      />
      <StepTiga
        prevStep={prevStep}
        total={total}
        formUMK={formUMK}
        rencImp={rencImp}
        anggaranRencimpUMK={anggaranRencimpUMK}
        formType={FORM_TYPE.Edit}
      />
    </FormStepContainer>
  );
};

export default UbahUMK;
